export const isDisabled = (formValues, requiredFields = []) => {
  if(formValues.type === 'Video') return !formValues.image && !formValues.Embed

  return requiredFields.some(field => !formValues[field])
}